import { Injectable } from '@angular/core';
import { DatePipe,LowerCasePipe, TitleCasePipe, UpperCasePipe } from '@angular/common';
import { ServerconfigService } from './core/serverconfig.service';
import { AppInjector } from './app-injector.module';
import { HttpParams } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class SystemFunctionsService {
  static datePipe: DatePipe = new DatePipe(navigator.language);
  static serverConfig: ServerconfigService = new ServerconfigService() ;
  static serviceLookup={
      };
  constructor() { }

static GetQueryString(key: string) {
    const url = window.location.href;
    let paramValue = '';
    if (url.includes('?')) {
      const params = new HttpParams({ fromString: url.split('?')[1] });
      paramValue = params.get(key);
    }
    return paramValue;
}

public static pipes = {
    'uppercase': new UpperCasePipe(),
    'lowercase': new LowerCasePipe(),
    'titlecase': new TitleCasePipe()
  };

public static PipeForKey(key: string) {
    return SystemFunctionsService.pipes[key];
  }
static GetConfiguration(key: string): string{
    return this.serverConfig.getBaseUrl(key);
}

static Concat(...args: any[]) {
    let result = "";
    for (let i = 0; i < arguments.length; i++) {
      result += arguments[i];
    }
    return result;
}
static Today(){
    return new Date();
}
static Year(date: Date){
    if(date)
        return new Date(date).getFullYear();
    else
        return new Date().getFullYear();
}
static AgeFromDOB(birthday: Date) {      
    var now = new Date();
    var past = new Date(birthday);
    var nowYear = now.getFullYear();
    var pastYear = past.getFullYear();
    if (pastYear < nowYear) {
        var age = nowYear - pastYear;
        return age;
    }
    return 0;
}
static Month(date: Date) {
    if (date)
        return new Date(date).getMonth() + 1;
    else
        return new Date().getMonth() + 1;
}
static Date(date) {       
    if (date)
        return new Date(date).getDate();
    else
        return new Date().getDate();
}
static AggregateSum(lstitems:any[], property ?: string) {
    var sum = 0;
    if (lstitems && lstitems.length > 0) {
        if (property) {
            for (var i = 0; i < lstitems.length ; i++) {
                var value = eval('lstitems[' + i + '].' + property);
                if (value && value != null)
                    sum += parseFloat(value);
            }
        }
        else {
            for (var i = 0; i < lstitems.length; i++) {
                if (lstitems[i] && lstitems[i] != null)
                    sum += parseFloat(lstitems[i]);
            }
        }
    }
    return sum;
}


static GetGUID(){
    var d = new Date().getTime();
    var uuid = 'xxxxxxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
}


  static Stringify(obj : any): string{
    return JSON.stringify(obj);     
  }
  static Parse<T>(str: string): T {
    return JSON.parse(str);
  }

  
  static AbsValue(value: number): number{
    return Math.abs(value);
  }
  static ACos(value: number): number{
    return Math.acos(value);
  }
  static ASin(value: number): number{
    return Math.asin(value);
  }
  static ATan(value: number): number{
    return Math.atan(value);
  }
  static Atan2(value1: number, value2: number): number{
    return Math.atan2(value1,value2);
  }
  static Ceil(value : number): number{
    return Math.ceil(value);
  }
  static Floor(value : number): number{
    return Math.floor(value);
  }
  static Cos(value : number): number{
    return Math.cos(value);
  }
  static Sin(value : number): number{
    return Math.sin(value);
  }
  static Tan(value : number): number{
    return Math.tan(value);
  }
  static SquareRoot(value : number): number{
    return Math.sqrt(value);
  }
  static Exp(value : number): number{
    return Math.exp(value);
  }
  static Log(value: number): number{
    return Math.log(value);
  }
  static MaxValue(value : number[]): number{
    return Math.max(...value);
  }
  static MinValue(value : number[]): number{
    return Math.min(...value);
  }
  static Power(basevalue : number, power : number): number{
    return Math.pow(basevalue,power);
  }
  static Random(): number{
    return Math.random();
  }
  static Round(x : number, digits : number): number{
    if(digits > 0){
      const op = x.toFixed(digits);
      return parseInt(op);
    }
    else{
      return Math.round(x);
    } 
  }
  static ToString(ip : any):string{
    return ip.toString();
  }
  static CharAt(str: string, pos : number):string{
    return str.charAt(pos);
  }
  static CharUnicode(str: string, pos : number):number{
    return str.charCodeAt(pos);
  }
  static SubString(ip: string, start: number, end?: number):string{
    if(end > 0){
      return ip.substring(start, end);
    }
    else{
      return ip.substring(start);
    }
  }
  static IndexOf(str : string, substr : string, pos ?: number):number{
    if(pos > 0){
      return new String(str).indexOf(substr, pos);
    }
    else{
      return new String(str).indexOf(substr);
    } 
  }
  static LastIndexOf(str : string, substr : string, pos ?: number):number{
    if(pos > 0){
      return new String(str).lastIndexOf(substr, pos);
    }
    else{
      return new String(str).lastIndexOf(substr);
    }
  }
  static StringCompare(str1 : string, str2 ?: string):number{
    return str1.localeCompare(str2);
  }  
  static Replace(str : string, subStr : string, newSubStr : string):string{ 
    return str.replace(subStr, newSubStr);
  }
  static Search(ip: string, searchStr : string):number{
    return ip.search(searchStr);
  }
  static Slice(ip:string, start?: number, end?: number):string{
    return ip.slice(start, end);
  }
  static Split(ip:string, separator: string):string[]{
    return ip.split(separator);
  }
  static LowerCase(str : string):string{
    return str.toLowerCase();
  }
  
  static UpperCase(str : string):string{
    return str.toUpperCase();
  }
  static Trim(str : string):string{
    return str.trim();
  }
  static StartsWith(input:string, start:string):boolean{
    return input.startsWith(start);
  }
  static EndsWith(input:string, end:string):boolean{
    return input.endsWith(end);
  } 
  static Contains(ip : string, str:string): boolean{
    return ip.includes(str);
  }
  static StrEquals(str1: string, str2:string): boolean{
    return (str1 === str2);
  }
  static EqualsIgnoreCase(str1 : string, str2 : string): boolean{
    return (str1.toLowerCase() === str2.toLowerCase());
  }
  static IsNullOrEmpty(ip : string): boolean{
    return (ip == null || ip == "");
  }
  static GetLength(input : string): number{
    return input.length;
  }


  
  static DateToUTCString(datevalue : Date): string{
    if(datevalue)
        return datevalue.toUTCString();
  }
  static DateToISOString(datevalue : Date): string{
    if(datevalue)
        return datevalue.toISOString();
  }
  static ToDateOnlyString(datevalue : Date): string{
    if(datevalue)
        return datevalue.toDateString();
  }
  static ToTimeOnlyString(datevalue : Date): string{
    if(datevalue)      
        return datevalue.toTimeString();
  }
  static ToLocaleString(datevalue : Date, localetype ?: string, excludeTime?: boolean): string{
    if(datevalue){
        if(localetype){
          if(excludeTime){
            return datevalue.toLocaleDateString(localetype);
          }
          else{
            return datevalue.toLocaleString(localetype);
          }
        }
        else{
          if(excludeTime){
            return datevalue.toLocaleDateString();
          }
          else{
            return datevalue.toLocaleString();
          }
        }
    }
  }
  static TimeLocaleStr(datevalue : Date): string{
    if(datevalue)
        return datevalue.toLocaleTimeString();
  }
  static DateValueOf(datevalue : Date): number{
    if(datevalue)
        return datevalue.valueOf();
  }
  static Time(datevalue : Date): number{
    if(datevalue)
        return datevalue.getTime();
  }
  static FullYear(datevalue : Date): number{
    if(datevalue)
        return datevalue.getFullYear();
  }
  static UTCFullYear(datevalue : Date): number{
    if(datevalue)
        return datevalue.getUTCFullYear();
  }
  static UTCMonth(datevalue : Date): number{
    if(datevalue)
        return datevalue.getUTCMonth();
  }
  static UTCDate(datevalue : Date): number{
    if(datevalue)
        return datevalue.getUTCDate();
  }
  static Day(datevalue : Date): number{
    if(datevalue)
        return datevalue.getDay();
  }
  static UTCDay(datevalue : Date): number{
    if(datevalue)
        return datevalue.getUTCDay();
  }
  static Hours(datevalue : Date): number{
    if(datevalue)
        return datevalue.getHours();
  }
  static UTCHours(datevalue : Date): number{
    if(datevalue)
        return datevalue.getUTCHours();
  }
  static Min(datevalue : Date): number{
    if(datevalue)
        return datevalue.getMinutes();
  }
  static UTCMin(datevalue : Date): number{
    if(datevalue)
        return datevalue.getUTCMinutes();
  }
  static Seconds(datevalue : Date): number{
    if(datevalue)
        return datevalue.getSeconds();
  }
  static UTCSeconds(datevalue : Date): number{
    if(datevalue)
        return datevalue.getUTCSeconds();
  }
  static MilliSeconds(datevalue : Date): number{
    if(datevalue)
        return datevalue.getMilliseconds();
  }
  static UTCMilliSeconds(datevalue : Date): number{
    if(datevalue)
        return datevalue.getUTCMilliseconds();
  }
  static TimeZoneOffset(datevalue : Date): number{
    return datevalue.getTimezoneOffset();
  }
  static AddDate(date: Date, value : number, type : string): Date{
    if(date && type){
        switch(type){
        case "y":
          date.setFullYear(date.getFullYear() + value);
          return date;
        case "M":
          date.setMonth(date.getMonth() + value);
          return date;
        case "d":
          date.setDate(date.getDate() + value); 
          return date;      
        case "h":
          date.setHours(date.getHours() + value);
          return date;
        case "m":
          date.setMinutes(date.getMinutes() + value);
          return date;
        case "s":
          date.setSeconds(date.getSeconds() + value);
          return date;
        }
     }
    
  }

  static SubtractDate(date: Date, value : number, type : string): Date{
    if(date && type){
       switch(type){
        case "y":
          date.setFullYear(date.getFullYear() - value);
          return date;
        case "M":
          date.setMonth(date.getMonth() - value);
          return date;
        case "d":
          date.setDate(date.getDate() - value); 
          return date;      
        case "h":
          date.setHours(date.getHours() - value);
          return date;
        case "m":
          date.setMinutes(date.getMinutes() - value);
          return date;
        case "s":
          date.setSeconds(date.getSeconds() - value);
          return date;
        }
    }
  }

  static IsLeapYear(year : number): boolean{
    return new Date(year, 1, 29).getDate() === 29;
  }
  static FormatDate(date : Date, format:string): string{
    if(date && format){
     switch(format.toLocaleLowerCase()){
       case "short":
         return this.datePipe.transform(date, 'M/d/yy, h:mm a');
       case "long":
        return this.datePipe.transform(date, 'MMMM d, y, h:mm:ss a z');
        case "medium":
          return this.datePipe.transform(date, 'MMM d, y, h:mm:ss a');
        case "full":
          return this.datePipe.transform(date, 'EEEE, MMMM d, y, h:mm:ss a zzzz');
        case 'shortdate':
          return this.datePipe.transform(date, 'M/d/yy');
        case "mediumdate":
          return this.datePipe.transform(date, 'MMM d, y');
        case "longdate":
          return this.datePipe.transform(date, 'MMMM d, y');
        case "fulldate":
          return this.datePipe.transform(date, 'EEEE, MMMM d, y');
        case "shorttime":
          return this.datePipe.transform(date, 'h:mm a');
        case "mediumtime":
          return this.datePipe.transform(date, 'h:mm:ss a');
        case "longtime":
          return this.datePipe.transform(date, 'h:mm:ss a z');
        case "fulltime":
          return this.datePipe.transform(date, 'h:mm:ss a zzzz');
        default :
          return this.datePipe.transform(date, 'EEEE, MMMM d, y, h:mm:ss a zzzz'); ;         
     }
    }
        
  }
  static ParseDate(date: string, pattern: string): Date {
    if(date)
        return new Date(this.datePipe.transform(date, pattern));
  }

  static DateDiff(interval: string, fromDate: Date, toDate: Date): number {
    const intervaltype = new Map<string, number>([
      ["d", 1000 * 60 * 60 * 24],
      ["m", 1000 * 60 * 60 * 24 * 30.4375],// average number of days in a month (365.25/12)
      ["y", 1000 * 60 * 60 * 24 * 365],
    ]);
  
    if (fromDate && toDate && intervaltype.has(interval)) {
        const timeDiff = toDate.getTime() - fromDate.getTime();
        return Math.round(timeDiff / intervaltype.get(interval));
    } else {
      return 0;
    }
  }

   static CalculateBusinessDays(fromDate:Date,toDate: Date, excludeWeekends:boolean, excludeHolidays:boolean){
    if(fromDate && toDate && (fromDate <= toDate)){
    let fromDateCopy = new Date(fromDate.getTime());
    let toDateCopy = new Date(toDate.getTime());
    let weekendDaysToExclude:number[]=[];
    let daysToExclude:Date[]=[];
    let weekendMapping:Map<string,number>=new Map<string,number>();
    weekendMapping.set("sunday",0);
    weekendMapping.set("monday",1);
    weekendMapping.set("tuesday",2);
    weekendMapping.set("wednesday",3);
    weekendMapping.set("thursday",4);
    weekendMapping.set("friday",5);
    weekendMapping.set("saturday",6);
    if(excludeWeekends){
      let weekends:string=this.GetConfiguration('Holidays:Weekends');
      if(weekends){
      weekends=weekends.toLocaleLowerCase();
      let weekend:string[]=weekends.split(',');
      weekend.forEach(x=>{
        if(weekendMapping.has(x))
        weekendDaysToExclude.push(weekendMapping.get(x));
      });
      }
    }
    if(excludeHolidays){
      let recurringholidays:string=this.GetConfiguration('Holidays:RecurringHolidays');
      if(recurringholidays){
      let holiday:string[]=recurringholidays.split(',');
      holiday.forEach(x=>daysToExclude.push(new Date(x)));
      }
      let otherholidays:string=this.GetConfiguration('Holidays:OtherHolidays');
      if(otherholidays){
      let holiday:string[]=otherholidays.split(',');
      holiday.forEach(x=>daysToExclude.push(new Date(x)));
      }
    }
    const differenceInMs: number = toDateCopy.getTime() - fromDateCopy.getTime();
    const differenceInDays: number = Math.floor(differenceInMs / 86400000);
    let remainingDays=differenceInDays+1;
      let currentDate=fromDateCopy;
      while (currentDate <= toDateCopy) {
        const dayOfWeek = currentDate.getDay();
        if (weekendDaysToExclude.includes(dayOfWeek)) {
          remainingDays--;
        } else {
          const excludeDate = daysToExclude.find(excludeDate => {
            // const excludeYear = excludeDate.getFullYear();
            const excludeMonth = excludeDate.getMonth()+1;
            const excludeDay = excludeDate.getDate();
            // const currentYear = currentDate.getFullYear();
            const currentMonth = currentDate.getMonth()+1;
            const currentDay = currentDate.getDate();
            return  excludeMonth === currentMonth && excludeDay === currentDay;
          });
          if (excludeDate) {
            remainingDays--;
          }
        }
        currentDate.setDate(currentDate.getDate() + 1);
      }
      return remainingDays;
  }
  return 0;
}

static DaysInMonth (year: number, month: number) {
  if(month >= 1 && month <= 12 && year >= 1 && year <= 9999){
    return new Date(year, month, 0).getDate();
  }
}

static CallClientFlow(serviceName:string,functionName:string,...args: any[]) {
  const dynamicService = AppInjector.get(this.serviceLookup[serviceName]);
  return dynamicService[functionName](...args);
}

  static ConcatArray<T>(arr1: T[], arr2: T[]): T[] { 
    return arr1.concat(arr2);
  }
  static ArrayContains<T>(arr1: T[], key: T): boolean {
    return arr1.includes(key);
  }
  static RemoveItems<T>(arr1: T[], values: T[]): void {
    if (arr1!=undefined && arr1.length > 0 && values != undefined && values.length>0) {
      for (let i in values) {
        let ind = arr1.findIndex(y=>values[i]==y);
        if (ind >= 0)
        arr1.splice(ind, 1);
      }
    }
  }
  static GetLastIndexByItem<T>(ip: T[], find: T): number {
    return ip.lastIndexOf(find);
  }
  static GetIndexByItem<T>(ip: T[], find: T): number {
    return ip.indexOf(find);
  }
  static Sort<T>(ip: T[]): T[] {
    return ip.sort();
  }
  static Join(ip:any[], element:string): string{
    return ip.join(element);
  }
  static Reverse<T>(ip: T[]): T[]{
    return ip.reverse();
  }
  static AddItemToArray<T>(item: T, items: T[], index?: number) {
    if (index != undefined && index <= items.length) {
      items.splice(index, 0, item);
    }
    else{
      items.push(item);
    }
  }

  static RemoveItemByIndex<T>(array: T[], index: number) {
    if (index != undefined && array.length > index) {
      array.splice(index, 1);
    }
  }
  static ItemByIndex<T>(ItemsArray: T[], index: number) {
    if (ItemsArray != null && ItemsArray.length > 0 && ItemsArray.length > index) {
      return ItemsArray[index];
    }
    return null;
  }

  static Length<T>(item: T[]) {
    if (item.length != undefined) return item.length;
    return -1;
  }
  static CopyArray<T>(ip: T[]): T[] {
    return [...ip];
  }
    static Clear<T>(ip: T[]) : void{
    ip.splice(0);
  }
  static AppendItems<T>(arr1: T[], arr2: T[]): void {
    arr1.push(...arr2);
  }
  static SliceItems<T>(ip: T[], start?: number, end?: number):T[] {
    return ip.slice(start, end);
  }

  static ParseInt(value : string): number{
    if(value && value != null){
      return Number(value);
    }
  }
  static ParseDouble(value : string): number{
    if(value && value != null){
      return Number(value);
    }
  }
  static ParseLong(value : string): number{
    if(value && value != null){
      return Number(value);
    }
  }
  static ConvertToLong(value : number): number{
    if(value && value != null){
      return Math.round(value);
    }
  }
  static ConvertToInt(value : number): number{
    if(value && value != null){
      return Math.round(value);
    }
  }
  static Encode(ip : string): string{
    return btoa(ip);
  }
  static Decode(ip : string): string{
    return atob(ip);
  }
  static CopyObject(ip:any): any{
    return {...ip};
  }
  static ConsoleLog(...data: any[]){
    console.log(...data);
  }
  static GetFormdata(files:any)
  {
    let filesToUpload : File[] = files;
    const formData = new FormData();
    
    Array.from(filesToUpload).map((file, index) => {
      return formData.append('file'+index, file,  file.name.replaceAll(' ', '_'));
    });
    return formData;
  }

  static CreateFormData() {
    return new FormData();
  }
 
  static AddStringToFormData(content: string, name: string, formData: any) {
    formData.append( name, content);
  }
 
  static AddFileToFormData(file: any, name: string,  formData: any) {
    formData.append(name.replaceAll(' ', '_'), file, file.name.replaceAll(' ', '_'));
  }
 
  static AddMultipleFilesToFormData(files: any, name: string, formData: any) {
    let filesToUpload: File[] = files;
 
    if (filesToUpload) {
      Array.from(filesToUpload).map((file, index) => {
        return formData.append(name.replaceAll(' ', '_') , file, file.name.replaceAll(' ', '_'));
      });
    }
  }
 
  static AddObjectToFormData(content: any, name: string, formData: any) {
    formData.append(name, JSON.stringify(content));
  }


  static Add<T, U>(map: Map<T, U>, key: T, value: U) : void{
    map.set(key,value);
  }
  static Remove<T, U>(map: Map<T, U>, key: T): boolean {
    return map.delete(key);
  }
  static RemoveAll<T, U>(map: Map<T, U>) : void {
    map.clear();
  }
  static ContainsKey<T, U>(map: Map<T, U>, key: T): boolean {
    return map.has(key);
  }
  static Count<T, U>(map: Map<T, U>): number {
    return map.size;
  }
  static GetValue<T, U>(map: Map<T, U>, key: T): U {
    return map.get(key);
  }
  static GetKeys<T, U>(map: Map<T, U>): any {
    return map.keys();
  }
  //Web Storage Functions
  static GetFromSessionStorage(key:string):any 
  {
    try 
    {
        if (sessionStorage.getItem(key) !== null) 
            return JSON.parse(sessionStorage.getItem(key)); 
        return null;
    } 
    catch (e) 
    {
        return sessionStorage.getItem(key);
    }
   }
  static AddToSessionStorage(key:string, value:any):void 
  { 
    if (typeof value === 'string') { 
        sessionStorage.setItem(key, value) 
    } 
    else { 
        sessionStorage.setItem(key, JSON.stringify(value)) 
    } 
  }
  static ClearSessionStorage():void 
  { 
    sessionStorage.clear(); 
  }
  static RemoveFromSessionStorage(key:string):void 
  { 
    sessionStorage.removeItem(key); 
  }
  static GetFromLocalStorage(key:string):any 
  { 
    try {
        if (localStorage.getItem(key) !== null) 
            return JSON.parse(localStorage.getItem(key)); 
        return null; 
    } 
    catch (e) {
        return localStorage.getItem(key);
    }
  }
  static AddToLocalStorage(key:string, value:any):void 
  { 
    if (typeof value === 'string') { 
        localStorage.setItem(key, value) 
    } 
    else { 
        localStorage.setItem(key, JSON.stringify(value)) 
    } 
  }
  static ClearLocalStorage():void 
  { 
    localStorage.clear(); 
  }
  static RemoveFromLocalStorage(key:string):void 
  { 
    localStorage.removeItem(key); 
  }

  static IfElse<T>(expression: boolean, value1: T, value2: T): T {
    if (expression) {
      return value1;
    } 
    else {
      return value2;
    }
  }

  static UrlEncode(value: string): string {
    return encodeURI(value);
  }

  static UrlDecode(encodedValue: string): string {
    return decodeURI(encodedValue);
  }
}
